<script lang="ts">
    import { _ } from "svelte-i18n";
    import Control from "../../components/map/controls/Control.svelte";
    import type { ForkToProjectControlManager } from "./ForkToProjectControlManager";

    export let manager: ForkToProjectControlManager;
    const canCreateProjectStore = manager.getCanCreateProjectStore();
</script>

{#if $canCreateProjectStore}
    <Control class="fork-to-project-control bg-transparant">
        <div class="d-flex w-100 justify-content-between">
            <button on:click={() => manager.createProject()}
                class="btn btn-primary shadow w-100"
                >Start for free <i class="fe fe-arrow-right ms-3"></i></button>
        </div>
    </Control>
{/if}
